import { render, staticRenderFns } from "./IndexDetail.vue?vue&type=template&id=0c7c0f3c&scoped=true"
import script from "./IndexDetail.vue?vue&type=script&lang=js"
export * from "./IndexDetail.vue?vue&type=script&lang=js"
import style0 from "./IndexDetail.vue?vue&type=style&index=0&id=0c7c0f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c0f3c",
  null
  
)

export default component.exports